export default __webpack_public_path__ + "static/media/farmaciasaojoao.05f23aca.jpg";